import createDOMPurify from 'dompurify';

/**
 * Sanitize docx-preview DOM in place so hostile hyperlinks (e.g. javascript:)
 * and inline event handlers cannot run inside the SPA.
 *
 * @param {Element|null|undefined} root
 */
export function sanitizeDocxPreviewHost(root) {
    if (!root || typeof window === 'undefined') {
        return;
    }

    const purify = createDOMPurify(window);

    purify.sanitize(root, {
        IN_PLACE: true,
        // docx-preview layout depends on classes and inline styles.
        ADD_ATTR: ['target', 'style'],
        ALLOW_UNKNOWN_PROTOCOLS: false,
    });
}
